import React, { useState, useMemo, useEffect } from 'react'
import CreatableSelect from './CreatableSelect'
import { 
  useWholesaleAllFavoriteQuery, 
  useWholesaleCreateFavoriteMutation, 
  useCheckFavoriteDealQuery, 
  useAddFavoriteDealMutation, 
  useRemoveFavoriteDealMutation 
} from '../services/wholesale'
import Button from './Button'
import Subheader from './Subheader'


export default function ProductFavorite({ product, region, onClose }) {
  let asin = Array.isArray(product.asin) ? product.asin[0] : product.asin
  let { data: items, isFetching: isFetchingItems } = useWholesaleAllFavoriteQuery()
  let { mutateAsync: createFavorite, isLoading: isCreatingFavorite } = useWholesaleCreateFavoriteMutation()
  let [selectedFavorite, setSelectedFavorite] = useState([])
  let { data: favoriteDeal, isFetching: isFavoriteDealLoading } = useCheckFavoriteDealQuery(product.asin)

  useEffect(() => {
    if (favoriteDeal) {
      setSelectedFavorite(favoriteDeal.all_favorite.map(item => item.favorite_id))
    }
  }, [favoriteDeal])

  let { mutateAsync: addFavoriteDeal, isLoading: isAddingFavoriteDeal } = useAddFavoriteDealMutation(asin)
  let { mutateAsync: removeFavoriteDeal, isLoading: isRemovingFavoriteDeal } = useRemoveFavoriteDealMutation(asin)

  let isLoading = isFetchingItems || isAddingFavoriteDeal || isRemovingFavoriteDeal || isCreatingFavorite || isFavoriteDealLoading
  let options = useMemo(() => items?.map(list => ({ label: list.favorite_name, value: list.favorite_id })), [items])

  return (
    <div className="flex flex-col gap-4 items-start bg-background p-8 rounded-lg w-[360px] sm:w-[600px] md:w-[700px] lg:w-[700px] relative overflow-auto">
      <Subheader subtitle='Wähle eine bestehende Favoriten Liste oder erstelle eine neue Liste'>
        <strong>Favorit</strong> hinzufügen
      </Subheader>

      <div className="w-full mt-4">
        <p className="text-sm mb-2">Produkt zu den folgenden Listen hinzufügen:</p>
        <div className='flex gap-2'>
          <CreatableSelect
            placeholder='Liste auswählen...'
            isMulti
            isClearable={false}
            value={selectedFavorite.map(id => options?.find(list => list.value === id))}
            allowCreateWhileLoading={false}
            options={options}
            onChange={async (option, meta) => {
              if (meta.removedValue) {
                setSelectedFavorite(selected => selected.filter(id => id !== meta.removedValue.value))
                await removeFavoriteDeal(meta.removedValue.value)
              } else if (meta.option) {
                setSelectedFavorite(selected => [...selected, meta.option.value])
                await addFavoriteDeal(meta.option.value)
              }
            }}
            onCreateOption={async (input) => {
              let { favorite_id } = await createFavorite({ favorite_name: input, region })
              setSelectedFavorite(selected => [...selected, favorite_id]);
            }}
            isLoading={isLoading}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </div>
      </div>

      <div className="w-full mt-4 text-center">
        <Button variant="info" onClick={onClose}>Erledigt</Button>
      </div>
    </div>
  )
}